import CityPageTemplate from "../city-template/CityPageTemplate";
import { traverseCityConfig } from "./data";

export default function TraverseCityPage() {
  return <CityPageTemplate config={traverseCityConfig} />;
}